<template>
    <div class="create">
        <portal to="title">Create user</portal>

        <vue-form-card class="mt-10">
            <template v-slot:title>User details</template>

            <template v-slot:description>
                Please be assured that this information will be private and stored securely
            </template>

            <template v-slot:body>
                <div class="row mt-5">
                    <div class="col-12 col-md-6">
                        <vue-text-input
                            v-model="form.firstName"
                            label="First name"
                            :required="true"
                            :errors="formErrors['firstName']"
                        />
                    </div>

                    <div class="col-12 col-md-6">
                        <vue-text-input
                            v-model="form.lastName"
                            label="Last name"
                            :required="true"
                            :errors="formErrors['lastName']"
                        />
                    </div>
                </div>

                <vue-text-input
                    class="mt-5"
                    label="Email"
                    :required="true"
                    :errors="formErrors['email']"
                    v-model="form.email"
                />

                <div class="alert show bg-light text-dark font-italic mt-8">
                    <i class="fa fa-info-circle text-primary mr-2"></i>
                    <small>
                        As a client profile manager, you can invite other users to access the profile. They will then be
                        able to make enquiries, view invoices, and so on, on behalf of the client.
                    </small>
                </div>
            </template>
        </vue-form-card>

        <div class="mb-5 text-center py-8">
            <button class="btn btn-outline-primary mr-4" type="button" v-on:click="$router.back()">Cancel</button>
            <button type="button" class="btn btn-primary w-50" v-on:click="create" :disabled="loading.create">
                <i class="fa fa-spinner fa-spin" v-if="loading.create"></i>
                Save
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueFormCard from '@components/formCard';
    import VueTextInput from '@components/textInput';

    import usersService from '@api/users';
    import addressesService from '@api/addresses';

    import { debounce } from 'lodash';

    export default Vue.extend({
        components: {
            VueFormCard,
            VueTextInput
        },
        data() {
            return {
                form: {
                    firstName: '',
                    lastName: '',
                    email: ''
                },
                formErrors: {},
                loading: {
                    create: false
                }
            };
        },
        methods: {
            create() {
                this.formErrors = {};
                this.loading.create = true;

                usersService
                    .create(this.form)
                    .then((response) => {
                        this.$router.push('/users');
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            this.formErrors = error.response.data.errors;
                            this.$toasted.error(
                                'Please enter a valid value in all the required fields before proceeding.',
                                { icon: 'exclamation-triangle' }
                            );
                            this.$goToError();
                        } else {
                            window.location.href = `/error/${error.response.status}`;
                        }
                    })
                    .finally(() => {
                        this.loading.create = false;
                    });
            }
        }
    });
</script>
